import { Auth } from '@entities/user'
import { createApi } from '@reduxjs/toolkit/query/react'
import { backendBaseQuery } from '@shared/api'

export interface JoinPayload {
  userPlatformId: string
  apiKey: string, 
  pin: string
}
// Define a service using a base URL and expected endpoints
export const authJoinApi = createApi({
  reducerPath: 'auth-join',
  baseQuery: backendBaseQuery,
  endpoints: (build) => ({
    join: build.mutation<Auth, JoinPayload>({
      query: (body) => ({
        url: `auth/join`, 
        method: 'POST',
        body
      }),
      transformResponse: (response: Auth, meta, arg) => response,
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useJoinMutation } = authJoinApi